<template>
    <div class="page-content view-bookSearch">

<div>
  <img :src="imgUrl+'/bookingSearch/banner.png'" class="banner" />

  <div class="wrapper">
    <div class="box">
      <div class="line"></div>
      <div class="title-search">通过船票订单查询您可以：</div>
    </div>

    <div class="content">
      <div class="item">*可绑定电话订单，查看订单详情并进行在线支付</div>
      <div class="item">*可绑定皇家加勒比国际游轮飞猪旗舰店，皇家加勒比游轮抖音店铺等官方平台的中国母港往返的航线订单，查看订单详情
      </div>
      <div style="margin-bottom: 10px;">*为已有订单预订皇家行前订(仅限中国出发航线订单)</div>
      <div class="item" style="margin-bottom: 5px;">温馨提示：</div>
      <div class="item">
        关联船票后，您可访问该订单下其他乘客的个人信息、办理在线登船手续、查看和修改订单信息、以及预订行前订产品
      </div>

    </div>

    <div class="switch-box">
      <div class="switch-box-btn" :class="[isInBorder ? 'switch-box-active':'']" @click="isInBorder = true">中国出发</div>
      <div class="switch-box-btn" :class="[!isInBorder ? 'switch-box-active':'']" @click="isInBorder = false">海外出发</div>
    </div>

    <div class="formBox">

     <div class="formBoxItem">
        <div class="icon">
          <div class="num">01</div>
          <div class="formLabel">船票订单号</div>
        </div>
        <div class="formContent">
          <input v-model="bookingId" type="text" class="formText" placeholder="不足7位请补0，例: 0012345">
          <div class="validateTips"></div>
        </div>
      </div>

       <div class="formBoxItem">
        <div class="icon">
          <div class="num">02</div>
          <div class="formLabel">姓(拼音)</div>
        </div>
        <div class="formContent">
          <input v-model="lastName" type="text" class="formText" placeholder="例如：WANG">
          <view class="validateTips"></view>
        </div>
      </div>

      <div class="formBoxItem">
        <div class="icon">
          <div class="num">03</div>
          <div class="formLabel">出生日期</div>
        </div>
        <div class="formContent">
           <div class="dateBox">
              <div class="formDate">
                <input type="text"
                  v-model="DateOfBirth"
                  class="formText"
                  style="position: absolute;left: 0;top: 0;z-index: 2;margin-top: 0;border: none;background-color: transparent;"

                  placeholder="请选择出航日期">
                <input type="date"
                  v-model="DateOfBirth"
                  class="formText2"
                  style="width:150%;opacity: 0;position: absolute;left: 0;top: 0;z-index: 3;"
                  :min="maxDateBirirth"
                  :max="minDateBirirth"
                  placeholder="请填写上述乘客对应的出生日期">
              </div>
              <img class="form-img" :src="imgUrl+'/bookingSearch/timer.png'" />
            </div>

          <view class="validateTips"></view>
        </div>
      </div>

      <div class="formBoxItem">
        <div class="icon">
          <div class="num">04</div>
          <div class="formLabel">所乘游轮</div>
        </div>
        <div class="formContent">
           <div class="dateBox">
              <div class="formDate">
                <select v-model="shipCode" class="formText3">
<!--                                <option value="WN">海洋奇迹号</option>-->
                                <!-- <option value="SC">海洋光谱号</option>
                                <option value="OV">海洋赞礼号</option> -->
                                <option :value="item.value" v-for="item in shipOrderList" :key="item.value">{{item.lable}}</option>
<!--                                <option value="QN">海洋量子号</option>-->
<!--                                <option value="VY">海洋航行者号</option>-->
                            </select>
              </div>
              <img class="form-img" style="width: 14px;height: 9px;margin-top: 0;" :src="imgUrl+'/bookingSearch/down.png'" />

            </div>

          <view class="validateTips"></view>
        </div>
      </div>


       <div class="formBoxItem">
        <div class="icon">
          <div class="num">05</div>
          <div class="formLabel">出航日期</div>
        </div>
        <div class="formContent">
           <div class="dateBox">
              <div class="formDate">
                <input type="text"
                  v-model="sailDate"
                  class="formText"
                  style="position: absolute;left: 0;top: 0;z-index: 2;margin-top: 0;border: none;background-color: transparent;"

                  placeholder="请选择出航日期">
                <input type="date"
                  style="width:150%;opacity: 0;position: absolute;left: 0;top: 0;z-index: 3;"
                  v-model="sailDate"
                  class="formText2"
                  :min="minDate"
                  :max="maxDate"
                  placeholder="请选择出航日期">
              </div>
              <img class="form-img" :src="imgUrl+'/bookingSearch/timer.png'" />
            </div>

          <view class="validateTips"></view>
        </div>
      </div>

      
      
      <div id="bookingSearchCaptchaSubmit" class="formBoxBtn">提交</div>

      <!-- <div class="history-box" @click="toTuiPage">
        <div >
          <div class="history-text">查询历史订单 <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/blueRightArrowImage.png" alt=""></div>
          <div class="history-tip">2026-01-09之前预订</div>
        </div>
      </div> -->


      
       <!-- 占位置 -->
       <div style="height: 56px;"></div>
       <!-- <div style="height: 70px;"></div> -->
    </div>
  </div>
</div>
      <ALiYunCaptcha :initPlugin="initPlugin"
                     :captchaReset="captchaReset"
                     trigger-element="#bookingSearchCaptchaSubmit"
                     @captchaSuccess="onCaptchaSuccess"
                     @captchaFail="onCaptchaFail"
                     @captchaReset="onCaptchaReset"></ALiYunCaptcha>
    </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
const ALiYunCaptcha = () => import('@/components/Plugin/ALiYunCaptcha.vue')
export default {
    name: "BookingSearch",
    components: {
        ALiYunCaptcha
    },
    data () {
        return {
            imgUrl: 'https://resource.rcclchina.com.cn/wechatMiniProgram',
            lastName: '',
            shipCode: 'SC',
            DateOfBirth: moment().format('yyyy-MM-DD'),
            sailDate: moment().format('yyyy-MM-DD'),
            bookingId: '',
            isInBorder: true,
            shipOrderList:[
                {
                  value:'SC',
                  lable:'海洋光谱号'
                },
                {
                  value:'OV',
                  lable:'海洋赞礼号'
                },
            ],
            // 验证
            initPlugin: "",
            isCaptchaAllow: false,
            captchaReset: "",
            captchaVerifyParam: ""
        }
    },
    mounted () {
        this.$store.commit('SET_PAGE_TITLE', '订单查询')
        const userToken = this.$store.state.user.userToken
        if (!userToken || userToken.length == 0) {
            this.$confirm.show('请登录后，再进行订单查询', {
                confirmCallBack: ()=> {
                    this.goToLogin()
                }
            })
        }

        const timer = setTimeout(()=> {
          clearTimeout(timer)
          this.initPlugin = (new Date()).getTime().toString();
        },100)
    },
    methods: {
      toTuiPage(){
        window.open(`${process.env.VUE_APP_TUI_URL}/UserCenter/MobileOrderRecord`)
      },
      toSeaOut(){
        window.open(this.rowSearchLink)
      },
        async submitBookingSearch () {
            if (!this.isCaptchaAllow) return;
            if (this.bookingId.trim() == '') {
                this.$alert.show('请输入订单号')
                return
            }
            if (this.lastName.trim() == '') {
                this.$alert.show('请输入姓(拼音)')
                return
            } else if (!this.pyNameCheck(this.lastName)) {
                this.$alert.show('请输入正确的姓(拼音)')
                return
            }

            if (this.DateOfBirth.trim() == '') {
                this.$alert.show('请填写上述乘客对应的出生日期')
                return
            }

            if (this.sailDate.trim() == '') {
                this.$alert.show('请选择出航日期')
                return
            }

            const requestData = {
                bookingId: this.bookingId,
                lastName: this.lastName,
                sailDate: this.sailDate,
                DateOfBirth: this.DateOfBirth,
                shipCode: this.shipCode,
                agencyId: '333545',
                sceneId: window.ALI_CAPTCHA_SCENE_ID,
                captchaVerifyParam: this.captchaVerifyParam
            }
            this.$loading.show()
            const { success, errMsg } = await api.booking.bookingSearch(requestData)
            this.$loading.hide()
            if (!success) {
                if (errMsg == 'USER_LOGIN_ERROR') {
                    return this.goToLogin()
                }
                // else if (errMsg == 'NvcNc' || errMsg == 'Block') {
                //   this.initPlugin = (new Date()).getTime().toString();
                //   return;
                // }
                this.$alert.show(errMsg)
                return
            }
            this.$router.push({ name: 'BookingDetail', query:{
                bookingId: this.bookingId
            }})
        },
        goToLogin () {
            this.$router.push({ name: 'Login', query:{
                returnUrl: location.href
            }})
        },
        pyNameCheck(pyName) {
            //中文验证
            if (!/^[A-Za-z]+$/.test(pyName)) {
                return false;
            }
            return true;
        },
        async onCaptchaSuccess(captchaRes) {
          try {
            this.isCaptchaAllow = true;
            this.captchaVerifyParam = captchaRes
            await this.submitBookingSearch();
          } finally {
            this.captchaReset = (new Date()).getTime().toString();
          }
        },
        onCaptchaFail() {
          this.isCaptchaAllow = false
        },
        onCaptchaReset() {
          this.isCaptchaAllow = false
        }
    },
    computed: {
        rowSearchLink () {
            return '/Rccl.Campaign/RedirectToTui?redirectUrl='+process.env.VUE_APP_TUI_URL +'/Booking/MobileBookingSearch'
        },
        minDate(){
          const year = moment().format('yyyy');
          return year+'-01-01'
        },
        maxDate(){
          const year = moment().add(2, 'year').format('yyyy');
          return year+'-12-31'
        },
        minDateBirirth(){
          // const year = moment().format('yyyy');
          return moment().format('yyyy-MM-DD')
        },
        maxDateBirirth(){
          const year = moment().format('yyyy');
          return (year -100)+'-12-31'
        }
    },
    watch:{
    isInBorder(newValue){
      console.log(newValue,'newValuenewValue')
      if(newValue == true){
        this.shipOrderList = [
          {
            value:'SC',
            lable:'海洋光谱号'
          },
          {
            value:'OV',
            lable:'海洋赞礼号'
          },
        ]
      }else{
        this.shipOrderList = [
          {
            value:'SY',
            lable:'海洋交响号'
          },
          {
            value:'HM',
            lable:'海洋和悦号'
          },
          {
            value:'AL',
            lable:'海洋魅丽号'
          },
          {
            value:'OA',
            lable:'海洋绿洲号'
          },
          {
            value:'MA',
            lable:'海洋水手号'
          },
          {
            value:'VY',
            lable:'海洋航行者号'
          },
          {
            value:'EX',
            lable:'海洋探险者号'
          },
          {
            value:'NV',
            lable:'海洋领航者号'
          },
          {
            value:'JW',
            lable:'海洋珠宝号'
          },
          {
            value:'QN',
            lable:'海洋量子号'
          },
          {
            value:'SC',
            lable:'海洋光谱号'
          },
          {
            value:'OV',
            lable:'海洋赞礼号'
          },
          {
            value:'RD',
            lable:'海洋灿烂号'
          },
          {
            value:'OY',
            lable:'海洋奥德赛号'
          },
          {
            value:'IC',
            lable:'海洋标志号'
          },
          {
            value:'WN',
            lable:'海洋奇迹号'
          },
          {
            value:'AN',
            lable:'海洋圣歌号'
          },
          {
            value:'SR',
            lable:'海洋旋律号'
          },
          {
            value:'UT',
            lable:'海洋乌托邦号'
          },
          {
            value:'BR',
            lable:'海洋光辉号'
          },
          {
            value:'LE',
            lable:'海洋神话号'
          },
          {
            value:'ST',
            lable:'海洋星际号'
          },
        ]
      }

      // 选中的邮轮重置
      this.shipCode  = this.shipOrderList[0].value
    }
  }
}
</script>

<style lang="less" scoped>
.view-bookSearch{
    width: 100%;
    overflow-x: hidden;
}
.banner {
  width: 100%;
  height: 226px;
}

.wrapper {
  width: 100%;
  padding: 23px 29px 0;
  border-radius: 20px 20px 0px 0px;
  margin-top: -50px;
  background-color: #fff;
  position: relative;
  z-index: 10;
  box-sizing: border-box;
}

.wrapper .content {
  width: 100%;
  font-weight: 400;
  font-size: 12px;
  color: #4A4A4A;
  margin-bottom: 15px;
}

.wrapper .content .item {
  font-weight: 400;
  font-size: 12px;
  color: #4A4A4A;
  margin-bottom: 2.5px;
}

.wrapper .box {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.wrapper .line {
  width: 3px;
  height: 13px;
  background: #286CF8;
  margin-right: 3px;
}

.wrapper .title-search {
  font-weight: 600;
  font-size: 14px;
  color: #232323;
}

.switch-box{
    width: 100%;
    height: 28px;
    background: #F7F7F7;
    box-shadow: inset 0px 0px 3px 3px rgba(0,0,0,0.08);
    border-radius: 13px;
    display: flex;
    align-items: center;

    font-weight: 400;
    font-size: 14px;
    color: #666666;

    margin-top: 24px;
    margin-bottom: 16px;
}
.switch-box-btn{
    width: 50%;
    height: 28px;
    line-height: 28px;
    text-align: center;
}
.switch-box-active{
  background: linear-gradient( 225deg, #00AEEA 0%, #006AB6 100%);
  border-radius: 13px;
  color: #fff;
}

.formBoxBtn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 35px;
  height: 46px;
  background: linear-gradient(90deg, #006BB7 0%, #00ACE9 100%);
  border-radius: 46px;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  margin-bottom: 10px;
}


.formBox {
  box-sizing: border-box;
  /* width: 100%; */
}

.formBoxItem {
  margin-bottom: 18px;
}

.formBoxItem .icon {
  display: flex;
  gap: 0 7.5px;
}

.formBoxItem .icon .num {
  width: 16px;
  height: 16px;
  background: linear-gradient(90deg, #2F87FC 0%, #35AAFF 100%);
  border-radius: 50%;
  font-weight: 500;
  font-size: 10px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2.5px;
}

.formBoxItem .icon .formLabel {
  font-weight: 500;
  font-size: 14px;
  color: #232323;
}

.formContent {
  width: 100%;
}

.formContent .formDesc {
  font-size: 11px;
  line-height: 14px;
  margin-top: 8px;
  color: #5a5a5a;
}

.formContent .formImportant {
  font-size: 9px;
  line-height: 12px;
  margin-top: 5px;
  color: #d10202;
}

.formContent .formText {
  font-size: 13px;
  padding: 0 22px;
  margin-top: 9px;
  box-sizing: border-box;
  width: 100%;
  height: 35px;
  line-height: 35px;
  border-radius: 4px;
  border: 1px solid #B6B6B6;
  color: #232323;
}

.formContent .dateBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  // height: 33px;
  position: relative;
  // margin-top: 5px;
}

.formContent .dateBox .dateText {
  width: 100%;
  height: 100%;
  padding-left: 12px;
  box-sizing: border-box;

}

.formContent .dateBox .dateIcon {
  display: block;
  width: 13.5px;
  height: 13.5px;
}

.formContent .formDate {
  font-size: 12px;
  margin-top: 9px;
  box-sizing: border-box;
  width: 100%;
  height: 37px;
  line-height: 37px;
  border-radius: 4px;
  border: 1px solid #B6B6B6;
  color: #323232;
  position: relative;
  box-sizing: border-box;
}
.formText2{
  font-size: 13px;
  padding: 0 22px 0 20px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  line-height: 35px;
  color: #232323;
  border: none;
  background-color: transparent;

}
.formText3{
  font-size: 13px;
  padding: 0 22px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  color: #232323;
  border: none;
  margin-top: -1px;
  background-color: transparent;
}
.form-img{
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  margin-top: -5px;
  right: 20px;
  z-index: -1;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    // opacity: 0;
}
select {
    -webkit-appearance: none; /* Chrome, Safari, Opera
    -moz-appearance: none;     /* Firefox */
    appearance: none;          /* 标准属性 */
}

.history-box{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.history-text{
  font-weight: 400;
  font-size: 14px;
  color: #2687BE;
  line-height: 20px;
  display: flex;
  align-items: center;
}
.history-text > img{
  width: 10px;
  height: 10px;
}
.history-tip{
  font-weight: 400;
  font-size: 10px;
  color: #B6B6B6;
  line-height: 14px;
}
</style>
